export const DIRECTIONS = {
  northWest: 'nw',
  north: 'n',
  northEast: 'ne',
  east: 'e',
  southEast: 'se',
  south: 's',
  southWest: 'sw',
  west: 'w',
};

export const CONNECTOR_SIDES = {
  top: 'top',
  right: 'right',
  bottom: 'bottom',
  left: 'left',
};

export const SHAPES = {
  rect: 'rect',
  line: 'line',
  arrowLine: 'arrow-line',
  bidirectionalArrowLine: 'bidirectional-arrow-line',
  circle: 'circle',
  ellipse: 'ellipse',
  rhombus: 'rhombus',
  parallelogram: 'parallelogram',
  process: 'process',
  document: 'document',
  storage: 'storage',
  image: 'image',
};

export const LINE_TYPES = {
  line: 'line',
  verticalCurve: 'verticalCurve',
  horizontalCurve: 'horizontalCurve',
  leftCurvedAngle: 'leftCurvedAngle',
  rightCurvedAngle: 'rightCurvedAngle',
  rightElbow: 'rightElbow',
  leftElbow: 'leftElbow',
  verticalStepped: 'verticalStepped',
  horizontalStepped: 'horizontalStepped',
};

export const STROKE_TYPES = {
  solid: 'solid',
  dashed: 'dashed',
};

export const FLOWCHART_MAX_POSITION_DIFF = 10;

export const FLOWCHART_MAX_TIMESTAMP_DIFF = 300;
